{#if $isUserLoggedIn}
  <TimelineHomePage/>
{:else}
  <NotLoggedInHome/>
{/if}
<script>
  import NotLoggedInHome from '../_components/NotLoggedInHome.html'
  import { store } from '../_store/store.js'
  import TimelineHomePage from '../_components/TimelineHomePage.html'
  import { observe } from 'svelte-extras'

  export default {
    store: () => store,
    methods: {
      observe
    },
    components: {
      NotLoggedInHome,
      TimelineHomePage
    }
  }
</script>
